import { useState, useEffect, useCallback } from 'react'
import { getPublicProjects } from '@/services/projects'

export const useProjects = (publicOnly = true) => {
  const [projects, setProjects] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  const fetchProjects = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const data = publicOnly ? await getPublicProjects() : []
      setProjects(data || [])
    } catch (err) {
      setError(err.message)
      setProjects([])
    } finally {
      setLoading(false)
    }
  }, [publicOnly])

  useEffect(() => {
    fetchProjects()
  }, [fetchProjects, refreshTrigger])

  const refresh = useCallback(() => setRefreshTrigger((p) => p + 1), [])

  return { projects, loading, error, refresh }
}
